<div class="overlay" *ngIf="showSpinner">
  <div class="spinner-wrapper">
    <app-spinner><span style="font-size: 3em; color: #27AE61;"><i class="fal fa-atom-alt fa-spin"></i></span></app-spinner>
  </div>
</div>
<package-receive-progress></package-receive-progress>

<div class="steps-content">
  <p-card>
    <ng-template pTemplate="title">
      Sender Address
    </ng-template>
    <ng-template pTemplate="subtitle">
      Identify where the package was sent from or go to the client search if address is not available
    </ng-template>
    <ng-template pTemplate="content">
      <div class="row">
        <div class="col-3 h4">
        </div>
        <div class="col-6">
          <div class="col-12">
            <div [hidden]="!package.FromCity">
              <B>{{package.FromName}}</B>
              <br />
              {{package.FromAddress1}}
              <br />
              {{package.FromCity}} {{package.FromState}} {{package.FromZipCode}}
            </div>
            <span [hidden]="package.FromCity && !inAddressSearch">
              <input style="width: 450px;" /><!--ngx-google-places-autocomplete [options]='options' (onAddressChange)="AddressChange($event)"-->
            </span>
          </div>
          <div class="col-3 h4">
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="footer">
      <div class="grid p-nogutter p-justify-between">
        <button (click)="prevPage()" icon="pi pi-angle-left" class="navbutton">Back</button>
        <button [hidden]="!package.FromCity" (click)="clearAddress()" icon="pi pi-angle-right" iconPos="right" class="navbutton">Clear Address</button>
        <button [hidden]="!package.FromCity" (click)="nextPage()" icon="pi pi-angle-right" iconPos="right" class="navbutton">Next</button>
      </div>
    </ng-template>
  </p-card>
</div>
<p-toast>
</p-toast>
